<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="['COMARCA', $lang.Common.DataTable.Actions]"
      :showNew="true"
      :showSearch="true"
      :showReload="true"
      :showTipFooter="false"
      v-on:New="onNew"
      v-on:Search="onShowSearch"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <tr
        v-for="obj in this.objList"
        v-bind:key="obj.id"
      >
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="obj.nome ? obj.nome.toUpperCase() : ''"
        />
        <td class="text-center">
          <div v-if="obj.inative">
            <b-dropdown
              variant="link"
              size="sm"
              no-caret
            >
              <template slot="button-content">
                <i
                  class="fa fa-lock-open text-secundary icone-grid"
                  style="color: black"
                  :title="$lang.GroupsConfig.UnlockGroupToolTip"
                ></i>
              </template>
              <b-dropdown-header
                ><strong>{{
                  $lang.GroupsConfig.ConfirmUnlockGroup
                }}</strong></b-dropdown-header
              >
              <b-dropdown-item
                href="javascript:void(0);"
                v-on:click="changeGroupStatus(obj, 'false')"
              >
                {{ $lang.Common.Yes }}
              </b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);">
                {{ $lang.Common.No }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div v-if="!obj.inative">
            <b-dropdown
              variant="link"
              size="sm"
              no-caret
            >
              <template slot="button-content">
                <i
                  class="fa fa-ban text-secundary icone-grid"
                  style="color: red"
                  :title="$lang.GroupsConfig.BlockGroupToolTip"
                ></i>
              </template>
              <b-dropdown-header>
                <strong>{{ $lang.GroupsConfig.ConfirmBlockGroup }}</strong>
              </b-dropdown-header>
              <b-dropdown-item
                href="javascript:void(0);"
                v-on:click="changeGroupStatus(obj, 'true')"
              >
                {{ $lang.Common.Yes }}
              </b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);">
                {{ $lang.Common.No }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </td>
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="$emit('New')"
          v-b-tooltip.hover
          :title="'Clique para cadastrar'"
        >
          <i class="fas fa-user-plus"></i>
          <span class="d-md-down-none">&nbsp; Nova</span>
        </button>
      </div>
    </div>
    <SidebarSearch
      label="Comarca"
      @search="onSearch"
    />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ComarcaRepository from '@/shared/http/repositories/configurations/comarca.js'
import { advancedOnException } from '@/components/tools/Utils'
import SidebarSearch from '@/views/private/configurations/ajuizamento/SidebarAjuizamento.vue'

export default {
  name: 'ComarcaList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  components: { SidebarSearch },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      if (this.filters) {
        ComarcaRepository.Search(
          this.createRequestComarcaram(),
          this.$refs.tableGrid.pagingLimit,
          this.$refs.tableGrid.pagingIndex
        )
          .then(this.onResultGrid)
          .catch((e) => advancedOnException(e, this.$lang))
      } else {
        ComarcaRepository.GetAllPaging(
          this.$refs.tableGrid.pagingLimit,
          this.$refs.tableGrid.pagingIndex
        )
          .then(this.onResultGrid)
          .catch((e) => advancedOnException(e, this.$lang))
      }
    },
    createRequestComarcaram () {
      let listComarcaram = []
      if (this.filters.nome && this.filters.nome !== undefined) {
        listComarcaram.push('nome=' + this.filters.nome.toString())
      }
      return listComarcaram.join('&')
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      ComarcaRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch((e) => advancedOnException(e, this.$lang))
    },
    changeGroupStatus (obj, status) {
      loading.push()
      let data = {
        inative: status
      }
      ComarcaRepository.ChangeStatus(obj.id, data)
        .then(() => {
          this.onLoadAll()
          loading.pop()
        })
        .catch((e) => advancedOnException(e, this.$lang))
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/ajuizamento/comarca/components/list/comarcalist.vue